import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import TypeImageField from "./TypeImageField";

const TypeForm = ({
  form,
  validationErrors,
  submitting,
  submitLabel = "Save Type",
  submittingLabel = "Saving...",
  isEditMode = false,
  readOnly = false,
  onSubmit,
  onFieldChange,
  onBack,
}) => {
  const disabled = submitting || readOnly;

  return (
    <Form onSubmit={onSubmit}>
      <h5 className="mb-3 mt-2">Basic Information</h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={form.name}
              onChange={(e) => onFieldChange("name", e.target.value)}
              placeholder="Premium"
              isInvalid={!!validationErrors.name}
              disabled={disabled}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={form.status}
              onChange={(e) => onFieldChange("status", e.target.value)}
              isInvalid={!!validationErrors.status}
              disabled={disabled}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {validationErrors.status}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={form.description}
              onChange={(e) => onFieldChange("description", e.target.value)}
              placeholder="Short description of this type"
              disabled={disabled}
            />
            {isEditMode ? (
              <Form.Text className="text-muted">
                Leave empty to clear the description.
              </Form.Text>
            ) : null}
          </Form.Group>
        </Col>
      </Row>

      <h5 className="mb-3 mt-2">Image</h5>
      <TypeImageField
        imagePath={form.image || ""}
        imageFile={form.imageFile}
        disabled={disabled}
        error={validationErrors.image}
        onFileChange={(file) => onFieldChange("imageFile", file)}
      />

      <div className="d-flex justify-content-end gap-2 mt-3">
        <Button
          type="button"
          variant="outline-secondary"
          onClick={onBack}
          disabled={submitting}
        >
          Cancel
        </Button>
        <Button type="submit" disabled={disabled}>
          {submitting ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              {submittingLabel}
            </>
          ) : (
            submitLabel
          )}
        </Button>
      </div>
    </Form>
  );
};

export default TypeForm;
